module.exports = __webpack_public_path__ + "img/image21.7181fed8.jpeg";